/**
 * 自动生成 router代码【模块名：分成锁定记录】
 * 生成日期：2025/12/15 16:16:16
 * 生成路径: src/router/artist_divide_lock.js
 * 生成人：超级管理员
 * 需要在文件 src/router/router.js 引入当前文件
 * import artist_divide_lock from './artist_divide_lock'
 // 路由详情
 const routes = [
 {
 path: '/',
 component: () => import('@/layouts/BasicLayout'),
 name: 'BasicLayout',
 meta: { title: '首页' },
 redirect: '/myNav',
 children: [
 ...
 artist_divide_lock,//分成锁定记录
 ]
 */

export default  {
  path: 'artist_divide_lock/list',
  name: 'artist_divide_lock',
  component: () => import('@/pages/artist_divide_lock/ArtistDivideLockList'),
  meta: { title: '分成锁定记录管理' },
}
